import { render, staticRenderFns } from "./gc-child-grid.vue?vue&type=template&id=b532fc80&"
import script from "./gc-child-grid.vue?vue&type=script&lang=js&"
export * from "./gc-child-grid.vue?vue&type=script&lang=js&"
import style0 from "./gc-child-grid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports